"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultListPropertyFormState = void 0;
var ListPropertyAvailability_1 = require("@/pages/listProperty/states/ListPropertyAvailability");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
exports.defaultListPropertyFormState = {
    buildingName: '',
    listingType: SfilterTypeGroup_1.ListingPurposeType.Sale,
    priceHkd: 0,
    rentAvailableType: ListPropertyAvailability_1.ListPropertyAvailability.RENT_AVAILABLE,
    rentAvailbleDate: '',
    saleAvailableType: ListPropertyAvailability_1.ListPropertyAvailability.SALE_VACANT,
    size: 0,
    beds: -1,
    baths: -1,
    features: [],
    comments: "",
    clientName: "",
    clientEmail: "",
    clientPhone: "",
    clientSubscribed: true,
    clientConsent: true,
    clientTerms: true,
};
